export default __webpack_public_path__ + "static/media/tickicon.3f2b6a49.svg";